// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1COh3","content":"styles_content__3taXz","tableWrap":"styles_tableWrap__1wZlO"};